/* eslint-disable max-len */

import { defineMessages } from 'react-intl'

export default defineMessages({
  title: 'freshcells on social media',
  subtitle: 'Follow us on our social media to stay updated',
  findUs: 'Find us on'
})
